import { gql } from '@apollo/client';
export const CREATE_FEEDBACK = gql(`
mutation CreateFeedback($rating: Int, $comment: String, $user_agent: String, $instance_id: Int, $region: String) {
  canx_create_feedback(rating: $rating, comment: $comment, user_agent: $user_agent, instance_id: $instance_id, region: $region) {
    data {
      id
      rating
      comment
      type
      user_agent
      instance_id
      model
      region
    }
    success
    error_message
  }
}
`);
